import { merge } from 'lodash';
import { chartOptionsTheme } from './chartOptionsTheme';
import { light } from '@mui/material/styles/createPalette';

export function createChartTheme(mode = 'light', overrides = {}) {
  const palette = chartOptionsTheme[mode].palette;

  const defaultTheme = {
    plugins: {
      legend: {
        labels: {
          color: palette.text.primary,
          font: { size: 12 },
        },
      },
      title: {
        color: palette.text.primary,
        font: {
          size: 14,
          weight: 'bold',
          family: 'system-ui, sans-serif',
        },
      },
      tooltip: {
        backgroundColor: palette.tooltip.bg,
        titleColor: palette.tooltip.title,
        bodyColor: palette.tooltip.body,
        borderColor: palette.tooltip.border,
      },
      dataLabelsPlugin: {
        fillStyle: mode === 'light' ? '#2c2c2cff' : '#e2e2e2ff',
      },
    },
    scales: {
      x: {
        grid: { color: palette.grid },
        ticks: { color: palette.text.primary },
      },
      y: {
        grid: { color: palette.grid },
        ticks: { color: palette.text.primary },
      },
    },
    datasetsTheme: {
      primary: {
        borderColor: '#38bdf8',
        backgroundColor: '#38bdf880',
      },
      secondary: {
        borderColor: '#22c55e',
        backgroundColor: '#22c55e80',
      },
      warning: {
        borderColor: '#facc15',
        backgroundColor: '#facc1580',
      },
    },
  };

  return merge(defaultTheme, overrides);
}
